import React, { useEffect, useMemo, useState } from 'react';
import Header from '../../newPages/NewLandingPage/Sections/Header/Header';
import Footer from '../../newPages/NewLandingPage/Sections/Footer/Footer';

import HeroSection from './components/HeroSection';
import LandscapeImpactSection from './components/LandscapeImpactSection';
import CommunityStoriesSection from './components/CommunityStoriesSection';
import PartnerCertificatesSection from './components/PartnerCertificatesSection';
import SharePageSection from './components/SharePageSection';
import SharePageModal from './components/SharePageModal';

import heroDesktop from './assets/hero-image.png';
import heroMobile from './assets/hero-mobile.png';
import partnerSeal from './assets/fallback_image.png';
import regeneraSeal from './assets/regenera-seal.png';
import roughTexture from './assets/roughTexture.png';
import mapBackground from './assets/mapBackground.png';
import BigLeaf from '../../assets/newAssets/left-leaf.webp';
import SmallLeaf from '../../assets/newAssets/right-leaf.webp';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Page } from '../../components';

import { searchBlogs, handleQueryLanguage } from '../Blogs/utils';
import * as coreAPI from '../../coreApi';

//species images
import aguilaArpia from '../../assets/especies/aguilaArpia.jpg';
import arahuana from '../../assets/especies/arahuana.jpg';
import camaronDeRio from '../../assets/especies/camaronDeRio.jpg';
import colibri from '../../assets/especies/colibri.jpg';
import colibriDeRaquetas from '../../assets/especies/colibriDeRaquetas.jpg';
import colibriDeVientreBlanco from '../../assets/especies/colibriDeVientreBlanco.jpg';
import condorAndino from '../../assets/especies/condorAndino.jpg';
import guacamayoEscarlata from '../../assets/especies/guacamayoEscarlata.jpg';
import jaguar from '../../assets/especies/jaguar.jpg';
import loboDeRio from '../../assets/especies/loboDeRio.jpg';
import mirloAcuático from '../../assets/especies/mirloAcuático.jpg';
import nutriaDeRio from '../../assets/especies/nutriaDeRio.jpg';
import osoDeAnteojos from '../../assets/especies/osoDeAnteojos.png';
import primate from '../../assets/especies/primate.jpg';
import tapir from '../../assets/especies/tapir.jpg';
import venadoDeColaBlanca from '../../assets/especies/venadoDeColaBlanca.jpg';
import vicunas from '../../assets/especies/vicunas.jpg';
import osoAndino from '../../assets/especies/osoAndino.png';
import gallitoDeLasRocas from '../../assets/especies/gallitoDeLasRocas.png';
import colibriPicoDeHoz from '../../assets/especies/colibriPicoDeHoz.png';

const speciesImages = {
    colibri: colibri,
    primate: primate,
    aguilaArpia: aguilaArpia,
    arahuana: arahuana,
    camaronDeRio: camaronDeRio,
    colibriDeRaquetas: colibriDeRaquetas,
    colibriDeVientreBlanco: colibriDeVientreBlanco,
    condorAndino: condorAndino,
    mirloAcuático: mirloAcuático,
    nutriaDeRio: nutriaDeRio,
    osoDeAnteojos: osoDeAnteojos,
    tapir: tapir,
    venadoDeColaBlanca: venadoDeColaBlanca,
    vicunas: vicunas,
    guacamayoEscarlata: guacamayoEscarlata,
    jaguar: jaguar,
    loboDeRio: loboDeRio,
    osoAndino: osoAndino,
    gallitoDeLasRocas: gallitoDeLasRocas,
    colibriPicoDeHoz: colibriPicoDeHoz,
};
//helpers
const formatNumber = value => {
    if (value === null || value === undefined || value === '') return '0';

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return value;

    const hasDecimals = Math.abs(numericValue % 1) > 0;

    return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: hasDecimals ? 0 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
    });
};

const formatCurrency = value => {
    if (value === null || value === undefined || value === '') return '$ 0';

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return `$ ${value}`;

    return `$ ${numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })}`;
};

const formatClimateMetric = value => {
    if (value === null || value === undefined || value === '') return '0';

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return value;

    return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

const extractNumber = (text, keyword) => {
    if (!text) return '0';
    const lines = text.split('\n');
    const line = lines.find(l => l.toLowerCase().includes(keyword.toLowerCase()));
    if (!line) return '0';
    const match = line.match(/\*\*(.*?)\*\*/);
    if (!match) return '0';
    return match[1];
};

const buildLandscapeCards = landscapes => {
    if (!Array.isArray(landscapes)) return [];

    return landscapes.map((l, index) => {
        const meta = l && l.landscape_metadata ? l.landscape_metadata : {};
        const species = Array.isArray(meta.species) ? meta.species : [];

        return {
            id: index + 1,
            landscapeName: l && l.landscape_name,

            hectaresProtected: extractNumber(meta.impact, 'hectáreas'),
            guardiansSupported: extractNumber(meta.red, 'guardianes'),

            landscapeExtent: extractNumber(meta.paisaje, 'hectáreas'),
            peopleBenefitted: extractNumber(meta.red, 'personas'),
            landscapePartners: extractNumber(meta.red, 'organizaciones'),

            lastYearContribution: '—',

            description: meta.description || '',
            impactDescription: meta.impact_description || '',

            species: species.slice(0, 3).map((name, i) => ({
                id: i + 1,
                name,
                image: speciesImages[name] || mapBackground,
            })),
        };
    });
};
const getPrimaryLandscapeName = landscapes => {
    if (!Array.isArray(landscapes) || !landscapes.length) return '';

    const firstLandscape = landscapes[0];
    return (firstLandscape && firstLandscape.landscape_name) || '';
};
const buildPublicProfileBulletPoints = organizationData => {
    const source =
        organizationData.publicProfileLines || organizationData.public_profile_lines || {};

    let parsedSource = source;

    if (typeof source === 'string') {
        try {
            parsedSource = JSON.parse(source);
        } catch (error) {
            parsedSource = {};
        }
    }

    return [parsedSource.line1, parsedSource.line2, parsedSource.line3]
        .map(item => (item || '').trim())
        .filter(Boolean);
};

const PublicProfilePage = ({ location, history, user, language, organizationSlug }) => {
    const [communityArticles, setCommunityArticles] = useState([]);
    const [organizationData, setOrganizationData] = useState(null);
    const [loadingOrganization, setLoadingOrganization] = useState(true);
    const [organizationNotFound, setOrganizationNotFound] = useState(false);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);

    const orgSlug = useMemo(() => {
        if (organizationSlug) return organizationSlug;

        const params = new URLSearchParams(location.search);
        return params.get('org');
    }, [organizationSlug, location.search]);

    useEffect(() => {
        const fetchPublicOrganization = async () => {
            try {
                if (!orgSlug) {
                    setOrganizationNotFound(true);
                    setLoadingOrganization(false);
                    return;
                }

                const result = await coreAPI.getPublicPartnerProfileBySlug(orgSlug);
                const orgData = (result && result.data) || result;

                if (!orgData) {
                    setOrganizationNotFound(true);
                    setOrganizationData(null);
                    return;
                }

                setOrganizationData(orgData);
                setOrganizationNotFound(false);
            } catch (error) {
                console.error('Failed to fetch public organization profile:', error);
                setOrganizationNotFound(true);
                setOrganizationData(null);
            } finally {
                setLoadingOrganization(false);
            }
        };

        fetchPublicOrganization();
    }, [orgSlug]);

    useEffect(() => {
        const fetchCommunityBlogs = async () => {
            try {
                if (!organizationData) return;

                const queryLang = await handleQueryLanguage(language);
                const primaryLandscapeName = getPrimaryLandscapeName(organizationData.landscapes);

                if (!primaryLandscapeName) {
                    setCommunityArticles([]);
                    return;
                }

                const result = await searchBlogs(
                    queryLang,
                    'null',
                    '',
                    [],
                    [primaryLandscapeName],
                    '',
                    '',
                    4
                );

                if (result && result.status === 'success' && result.data && result.data.nodes) {
                    setCommunityArticles(result.data.nodes.slice(0, 4));
                } else {
                    setCommunityArticles([]);
                }
            } catch (error) {
                console.error('Failed to fetch community blogs:', error);
                setCommunityArticles([]);
            }
        };

        fetchCommunityBlogs();
    }, [language, organizationData]);

    if (loadingOrganization) {
        return (
            <Page
                title="Public Profile | Regenera"
                description="View this Regenera Guardian's conservation profile and their contributions to protecting and restoring natural landscapes across Latin America."
                scrollingDisabled={false}
            >
                <div style={{ padding: '80px 24px', textAlign: 'center' }}>
                    Loading public profile...
                </div>
            </Page>
        );
    }

    if (organizationNotFound || !organizationData) {
        return (
            <Page
                title="Public Profile Not Found | Regenera"
                description="The public profile you are looking for cannot be found. Explore other Guardians and Partners contributing to nature conservation and landscape restoration across Latin America on Regenera."
                scrollingDisabled={false}
            >
                <div style={{ padding: '80px 24px', textAlign: 'center' }}>
                    Public profile not found.
                </div>
            </Page>
        );
    }

    const organizationName =
        organizationData.organizationName || organizationData.partnerName || 'Partner';

    const metrics = organizationData.metrics || {};
    const landscapes = Array.isArray(organizationData.landscapes)
        ? organizationData.landscapes
        : [];
    const primaryLandscapeName = getPrimaryLandscapeName(landscapes);
    const certificates = Array.isArray(organizationData.certificates)
        ? organizationData.certificates
        : [];
    const bulletPoints = buildPublicProfileBulletPoints(organizationData);

    const publicProfileData = {
        partnerName: organizationName,
        heroTitle: `${organizationName} takes positive action for Nature, people and climate `,
        statusTitle: `${organizationName} is actively taking responsibility for its impact on Nature.`,
        bulletPoints,
        stats: [
            {
                id: 1,
                value: formatNumber(Math.round(metrics.hectaresStewarded)),
                label: 'Hectares stewarded',
            },
            {
                id: 2,
                value: formatNumber(Math.round(metrics.guardiansSupported)),
                label: 'Guardians supported in managing their land',
            },
            {
                id: 3,
                value: formatClimateMetric(Math.round(metrics.climateFootprintRegenerated)),
                label: 'Climate footprint regenerated',
            },
            {
                id: 4,
                value: formatCurrency(Math.round(metrics.contributedToLandStewardshipSinceJoining)),
                label: 'Contributed to land stewardship since joining',
            },
        ],
        images: {
            desktopHero: heroDesktop,
            mobileHero: heroMobile,
            partnerSeal: organizationData.logoUrl || partnerSeal,
            regeneraSeal,
        },
    };

    const mappedLandscapeCards = buildLandscapeCards(landscapes).map(card => ({
        ...card,
        lastYearContribution:
            organizationData &&
            organizationData.metrics &&
            organizationData.metrics.lastYearContribution
                ? formatCurrency(organizationData.metrics.lastYearContribution)
                : '—',
    }));
    const landscapeHeadingName = organizationName;
    const firstLandscapeDescription =
        (landscapes &&
            landscapes[0] &&
            landscapes[0].landscape_metadata &&
            landscapes[0].landscape_metadata.description) ||
        'Their contributions allow indigenous and local Guardians to protect and restore land.';
    const firstLandscapeImpactDescription =
        (landscapes &&
            landscapes[0] &&
            landscapes[0].landscape_metadata &&
            landscapes[0].landscape_metadata.impact_description) ||
        'Their contributions allow indigenous and local Guardians to protect and restore land.';

    return (
        <Page
            title="Public Profile | Regenera"
            description="View this Regenera Partner's conservation profile and their contributions to protecting and restoring natural landscapes across Latin America on Regenera."
            scrollingDisabled={false}
        >
            {/* <Header currentPath={location.pathname} user={user} history={history} /> */}

            <HeroSection
                partnerName={publicProfileData.partnerName}
                heroTitle={publicProfileData.heroTitle}
                statusTitle={publicProfileData.statusTitle}
                bulletPoints={publicProfileData.bulletPoints}
                stats={publicProfileData.stats}
                images={publicProfileData.images}
            />

            <LandscapeImpactSection
                partnerName={landscapeHeadingName}
                numberOfCards={mappedLandscapeCards.length || 0}
                images={{
                    roughTexture,
                    mapBackground,
                }}
                landscapes={mappedLandscapeCards}
            />
            <PartnerCertificatesSection
                heading="Environmental footprint management and Nature stewardship take dedication and time."
                certificates={certificates}
            />
            <CommunityStoriesSection
                partnerName={landscapeHeadingName}
                heading={`${landscapeHeadingName} is supporting Guardians of ${primaryLandscapeName} to care for their land long-term.`}
                articles={communityArticles}
            />

            <SharePageSection
                partnerName={landscapeHeadingName}
                heading={`Share the good work of ${landscapeHeadingName}!`}
                description="Cool what they are doing, right? Spread the word and share this page in your network."
                partnerLogo={organizationData.logoUrl || partnerSeal}
                partnerSlug={organizationData.publicSlug}
                textureImage={roughTexture}
                smallLeaf={SmallLeaf}
                onShare={() => setIsShareModalOpen(true)}
            />

            <SharePageModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                partnerName={landscapeHeadingName}
                shareUrl={typeof window !== 'undefined' ? window.location.href : ''}
                partnerSlug={organizationData.publicSlug}
                partnerLogo={organizationData.logoUrl || partnerSeal}
            />

            <Footer history={history} />
        </Page>
    );
};

const mapStateToProps = storeState => ({
    user: storeState.user.currentUser
        ? {
              initials: storeState.user.currentUser.attributes.profile.abbreviatedName,
              name:
                  storeState.user.currentUser.attributes.profile.firstName +
                  ' ' +
                  storeState.user.currentUser.attributes.profile.lastName,
          }
        : null,
});

export default connect(mapStateToProps)(withRouter(PublicProfilePage));
